import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AlSection, AlTherActRow } from 'PatientCareCenter/Note/AL';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood } from '_components';


class AlTherAct extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false
        };
    }

    add() {
        if (this.props.trtValid || (!this.props.trtValid && this.props.theracts.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLTHERACT', 'XLTA', 'XLTANO', 'XLTAXLNO', this.props.xlno, 'NEW_XLTANO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid && this.props.theracts.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.theracts.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMETHERACT', 'XLTIMETHERACTASSIST', 'XLTIMETHERACTTHERAPIST']);
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLTHERACT', 'XLTA', 'XLTANO', 'XLTAXLNO', this.props.xlno, 'NEW_XLTANO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }

    render() {
        return (
            <AlSection
                id='al_theract'
                name='Therapeutic Activities (97530)'
                timeField='XLTIMETHERACT'
                timeRequired={this.props.containsPerformed && this.props.time === null ? true : false}
                timeVisible={this.props.theracts.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
            >

                {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.theracts.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>To Improve</span>
                        <span className={styles.col2_header}>Activity</span>
                        <span className={styles.col3_header}>Sets/Reps/Weight/Time</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }

                {Object.keys(this.props.theracts)
                    .map(key => {
                        const result = this.props.theracts[key];
                        return (
                            <AlTherActRow key={result.XLTANO} id={result.XLTANO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLTHERACT &&
        Object.keys(state.entities.notes.MLTHERACT)
            .filter(key => {
                return (state.entities.notes.MLTHERACT[key].XLTAXLNO === xlno && state.entities.notes.MLTHERACT[key].XLTAPERFORMED)
            }).length > 0 ? true : false;


    return {
        noteId,
        xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMETHERACT,
        trtValid: codeValidForAdmit(epno, '97530'),
        theracts: Object.keys(state.entities.notes.MLTHERACT)
            .filter(key => {
                return (state.entities.notes.MLTHERACT[key].XLTAXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLTHERACT[a].XLTANO - state.entities.notes.MLTHERACT[b].XLTANO)
            .map(key => state.entities.notes.MLTHERACT[key]),
        isLicensed,
        containsPerformed,
        trackAssist,
    };
}

const connectedAlTherAct = connect(mapStateToProps, mapDispatchToProps)(AlTherAct);
export { connectedAlTherAct as AlTherAct };

